export enum AgencyRelationship {
  NBA = 'NBA',
  STROMSOE = 'Stromsoe',
}

export const AgencyRelationshipDescriptionMap: Map<AgencyRelationship, string> = new Map([
  [AgencyRelationship.NBA, 'NBA'],
  [AgencyRelationship.STROMSOE, 'Stromsoe'],
]);
